import type { UiStrings } from "../types";

export const de: UiStrings = {
  nav: {
    category: "Kategorie",
    forYourWork: "Für Ihre Arbeit",
    searchPlaceholder: "Durchsuchen Sie über 300 Tools...",
    heroPlaceholder: "Was haben Sie vor?",
  },
  trustBadges: {
    noLogin: "Keine Anmeldung, um die Tools zu nutzen",
    freeUsesDaily: "10 Testnutzungen täglich",
    filesNeverStored: "Ihre Dateien werden niemals gespeichert",
    worksAnyDevice: "Funktioniert auf jedem Gerät",
    worksWhenAiBlocked: "Funktioniert unabhängig von der KI-Richtlinie Ihres Unternehmens",
    availableInLanguages: "In mehreren Sprachen verfügbar",
  },
  common: {
    backToHome: "Zurück zur Startseite",
    home: "Startseite",
    signIn: "Anmelden",
    account: "Konto",
    contact: "Kontakt",
    blog: "Blog",
    shareThisTool: "Dieses Tool teilen",
    download: "Herunterladen",
    copy: "Kopieren",
    copied: "Kopiert",
  },
  footer: {
    tagline: "Ihre All-in-One-Plattform für Produktivität. Über 300 professionelle Tools, Premium-Anwendungen und Workflow-Produkte für den Alltag.",
    company: "Unternehmen",
    about: "Über uns",
    blog: "Blog",
    contact: "Kontakt",
    pricing: "Preise",
    privacyPolicy: "Datenschutzerklärung",
    termsOfService: "Nutzungsbedingungen",
    allTools: "Alle Tools",
    allRightsReserved: "Alle Rechte vorbehalten.",
  },
  contact: {
    title: "Kontaktieren Sie uns",
    subtitle: "Fragen, Feedback oder funktioniert etwas nicht richtig? Wir helfen Ihnen gerne.",
    email: "E-Mail",
    responseTime: "Antwortzeit",
    responseTimeValue: "Wir antworten in der Regel innerhalb von 1-2 Werktagen.",
    sendEmail: "Senden Sie uns eine E-Mail",
    billingNote: "Bei Fragen zur Abrechnung geben Sie bitte die mit Ihrem Konto verknüpfte E-Mail-Adresse an.",
    whoWeAreTitle: "Wer FreeDailyPro betreibt",
    whoWeAreBody: "FreeDailyPro wird von DreamUSA LLC betrieben, einem kleinen, unabhängig geführten Softwareunternehmen. Es gibt kein großes Support-Team dahinter -- die Person, die Ihre E-Mail liest und beantwortet, ist auch diejenige, die die Tools entwickelt und pflegt, weshalb eine Antwort manchmal ein bis zwei Tage dauert, anstatt sofort zu erfolgen.",
    whatWeSupportTitle: "Womit wir helfen können",
    whatWeSupportBody: "Fehlerberichte für jedes der 300+ Tools, Funktionswünsche, Abrechnungs- und Abonnementfragen (einschließlich Kündigungen und Rückerstattungen), Konto- und Anmeldeprobleme sowie allgemeines Feedback dazu, was gut funktioniert oder nicht. Wenn ein Tool ein falsches Ergebnis produziert hat, hilft die Angabe des Dateityps und was ungefähr schiefgelaufen ist, es schneller zu beheben.",
  },
  home: {
    heroTitleLine1: "Jede professionelle Aufgabe.",
    heroTitleLine2: "Eine Browser-Plattform",
    heroSubtitle: "Nutzen Sie ein Tool. Führen Sie einen Workflow aus. Bauen Sie mit API und MCP. Oder lassen Sie uns Ihr Produkt entwickeln.",
    localSignalUsedTitle: "Auf diesem Gerät verwendet",
    localSignalTryTitle: "Probieren Sie eines davon",
    localSignalBadge: "Lokal \u00b7 Kein Netzwerk",
    localSignalUsedDesc: "Tools auf diesem Gerät verwendet \u2014 nichts hat Ihren Browser verlassen",
    localSignalTryDesc: "Tools bisher auf diesem Gerät verwendet \u2014 alles läuft direkt hier in Ihrem Browser",
    corporateSafeTitle: "Unternehmenssicher",
    corporateSafeSubtitle: "Egal welche KI-Richtlinie Ihr Unternehmen hat, FreeDailyPro funktioniert genauso",
    corporateSafeBlockedTitle: "Vollständig blockiert",
    corporateSafeBlockedDesc: "Keine Art von KI-Tools im Netzwerk erlaubt. Jedes FreeDailyPro-Tool funktioniert trotzdem \u2014 es wird nie etwas auf einen Server hochgeladen.",
    corporateSafeGovernedTitle: "Kontrollierter Zugang",
    corporateSafeGovernedDesc: "KI ist nur über genehmigte, geprüfte Tools erlaubt. Hier ist keine Genehmigung nötig \u2014 es gibt keinen externen Server-Aufruf zu prüfen.",
    corporateSafeOpenTitle: "Keine Einschränkungen",
    corporateSafeOpenDesc: "Nutzen Sie, was funktioniert. FreeDailyPro ist einfach schneller, da es nichts hochzuladen oder abzuwarten gibt.",
    corporateSafeCta: "Die vollständige Unternehmens-Übersicht ansehen \u2192",
    exploreToolkitTitle: "Entdecken Sie die Toolsammlung",
    exploreToolkitSubtitle: "Über 300 Tools in {catCount} Kategorien \u2014 wählen Sie eine aus oder suchen Sie einfach.",
    forYourWorkTitle: "Gemacht für Ihre Art zu arbeiten",
    forYourWorkSubtitle: "Dieselben professionellen Tools, organisiert nach Ihrem tatsächlichen Beruf",
    exploreTools: "Tools entdecken",
    seeAllRoles: "Alle {count} Bereiche ansehen \u2192",
    blogTitle: "Aus dem Blog",
    viewAllPosts: "Alle Beiträge Ansehen",
    faqTitle: "Haben Sie eine Frage? Schauen Sie in unsere FAQ",
    faqMoreLink: "Suchen Sie weitere Antworten? Durchsuchen Sie die vollständige FAQ \u2192",
    toolkitProseTitle: "Eine professionelle Toolsammlung für die tägliche Arbeit, nicht nur für Einzelaufgaben",
    closingCtaTitle: "Vergessen Sie nicht, die Verknüpfung hinzuzufügen",
    closingCtaDesc: "Einmal hinzufügen und immer nur einen Klick entfernt \u2014 installieren Sie die Desktop-Verknüpfung oder fügen Sie sie zum Startbildschirm Ihres Handys hinzu, dann öffnet sich FreeDailyPro wie eine native App, ohne Browser-Tab-Suche.",
    categoriesLabel: "{count} KATEGORIEN \u2192",
    viewAllCategoriesLabel: "ALLE {count} KATEGORIEN ANZEIGEN \u2192",
    yourFavorites: "Ihre Favoriten",
    recentlyUsed: "Zuletzt Verwendet",
    toolkitProsePara1: "FreeDailyPro bringt über 300 alltägliche Tools zusammen \u2014 PDF-Bearbeitung, Bildkonvertierung, Videoschnitt, Audio-Bereinigung, Textformatierung und Dutzende Rechner \u2014 an einem Ort, damit Sie nicht für jede Aufgabe eine andere Website aufrufen müssen. Die meisten Tools benötigen keine Anmeldung, und dateibasierte Tools bieten 10 kostenlose Nutzungen täglich.",
    toolkitProsePara2: "Jedes Tool läuft vollständig in Ihrem Browser. Wenn Sie ein PDF komprimieren oder den Hintergrund eines Fotos entfernen, verlässt diese Datei nie Ihr Gerät \u2014 sie wird nicht hochgeladen, auf einem Server verarbeitet oder irgendwo gespeichert, nicht einmal vorübergehend. Das ist keine Einschränkung, das ist das gesamte Konzept: schnellere Ergebnisse, und keine Sorgen, wenn die Datei sensibel ist.",
    toolkitProsePara3: "Dieser lokale Ansatz bedeutet auch, dass FreeDailyPro genauso funktioniert, egal ob auf einem privaten Laptop, einem gesperrten Arbeitsrechner oder einem Netzwerk mit strengen KI-Nutzungsrichtlinien \u2014 es gibt keinen externen Serveraufruf, den die IT-Abteilung prüfen müsste, weil es ihn schlicht nicht gibt.",
    toolkitProsePara4: "Ob Sie PDFs für einen Bericht zusammenführen, ein Bild für ein Inserat verkleinern, einen Videoclip für soziale Medien kürzen oder schnell eine Hypotheken- oder Steuerberechnung durchführen müssen \u2014 FreeDailyPro ist als das Tool gedacht, das Sie täglich nutzen, nicht nur das, an das Sie sich erinnern, wenn Sie es gerade brauchen.",
    heroLaneToolsTitle: "Professionelle Tools für einzelne Aufgaben",
    heroLaneToolsDesc: "PDF, Bild, Video und mehr -- eine Aktion, direkt in Ihrem Browser.",
    heroLaneToolsCta: "Tools durchsuchen",
    heroLanePremiumTitle: "Premium-Anwendungen für größere Aufgaben",
    heroLanePremiumDesc: "Mehrstufige Apps: Dokumente, Formulare, Planer, Druck und Event-Unterlagen.",
    heroLanePremiumCta: "Anwendungen ansehen",
    heroLaneWorkflowTitle: "Workflow-Produkte",
    heroLaneWorkflowDesc: "Book Writing Toolbox, Event Suite und mehr -- mehrere Schritte, ein Ergebnis.",
    heroLaneWorkflowCta: "Workflow-Produkte ansehen",
    heroLaneApiTitle: "API & MCP",
    heroLaneApiDesc: "Rufen Sie dieselben Tools aus Ihrem eigenen Code oder KI-Agenten auf.",
    heroLaneApiCta: "Entwicklerbereich öffnen",
    heroLaneCustomTitle: "Individuelle Software",
    heroLaneCustomDesc: "Sagen Sie uns, was Sie brauchen. Wir entwickeln es gegen eine einmalige Gebühr, danach zahlen Sie eine kleine monatliche Nutzungsgebühr.",
    heroLaneCustomCta: "Entwicklung anfragen",
  },
  install: {
    desktopTitle: "Desktop-Verknüpfung",
    desktopSubtitle: "Ein Klick, öffnet sofort",
    mobileTitle: "Mobile App",
    mobileSubtitle: "Zum Startbildschirm hinzufügen",
    addToHomeScreenTitle: "FreeDailyPro zum Startbildschirm hinzufügen",
    iosInstructions: "Tippen Sie in Safari auf das Teilen-Symbol und wählen Sie dann \"Zum Home-Bildschirm.\"",
    genericInstructions: "Öffnen Sie das Menü Ihres Browsers und suchen Sie nach \"Zum Startbildschirm hinzufügen\" oder \"App installieren.\"",
    desktopUnavailableTitle: "Die Ein-Klick-Installation ist in diesem Browser nicht verfügbar",
    desktopUnavailableDesc: "Sie können diese Seite trotzdem als Lesezeichen speichern oder das Adressleisten-Symbol auf Ihren Desktop ziehen.",
    desktopSuccess: "Verknüpfung erstellt! Suchen Sie nach dem FreeDailyPro-Symbol.",
    mobileSuccess: "Hinzugefügt! Suchen Sie nach dem FreeDailyPro-Symbol auf Ihrem Startbildschirm.",
  },
  toolPage: {
    proBadge: "Pro",
    usesRemainingToday: "{count} Testnutzungen heute übrig",
    whatThisToolDoes: "Was dieses Tool macht",
    proTips: "Pro-Tipps",
    continueWith: "Weiter mit",
    moreFromCategory: "Mehr aus dieser Kategorie",
  },
  usageStrip: {
    freeUsesPerDay: "Test: {limit} Nutzungen/Tag",
    remainingToday: "{count} heute übrig",
    dayPassLabel: "Werbefreie, unbegrenzte Nutzung, Tagespass für 1 $",
    monthlyLabel: "Werbefreie, unbegrenzte Nutzung, Monatspass für 4,99 $",
    quickBuy: "Schnellkauf",
  },
  platformsBanner: {
    title: "Wo diese API tatsächlich verfügbar ist",
    subtitle: "Keine Seite mit \"demnächst verfügbar\" -- das sind echte, funktionierende Einträge, die Sie heute abonnieren oder verbinden können.",
    postmanDetail: "Einsatzbereite Requests, vollständig dokumentiert",
    rapidApiDetail: "Abonnieren Sie mit nutzungsbasierter Abrechnung über den Rapid-Marktplatz",
    mcpRegistryDetail: "Offiziell gelistet als com.freedailypro/tools, {mcp} Tools, ein Endpunkt",
  },
  pricingBanner: {
    title: "Transparente Preise",
    subtitle: "Keine versteckten Stufen, keine überraschenden Limits -- genau das, was jeder Plan kostet und bietet.",
    toolPricingTitle: "Nutzungsbasierte Tool-Preise",
    apiPricingTitle: "Nutzungsbasierte API- & MCP-Preise",
    freeLabel: "Test",
    freeToolDetail: "10 Nutzungen/Tag bei Professional Tools, 2 bei Premium Applications",
    dayPassDetail: "1 $/Tag -- werbefreie, unbegrenzte Nutzung",
    monthlyDetail: "4,99 $/Monat -- werbefreie, unbegrenzte Nutzung",
    monthlySavingsNote: "Günstiger als 5 Tagespässe im Monat",
    freeApiDetail: "20.000 Aufrufe/Monat",
    premiumDetail: "24 $/Monat -- 200.000 Aufrufe",
    ultraDetail: "69 $/Monat -- 750.000 Aufrufe",
    megaDetail: "129 $/Monat -- 2.000.000 Aufrufe + Priorität",
  },
  apiMcpBanner: {
    title: "Jetzt mit API & MCP",
    description: "Rufen Sie unsere über 200 Tools direkt aus Ihrem eigenen Code auf, oder verbinden Sie einen KI-Agenten über MCP -- dieselben Tools, serverseitig, für wenn der Browser allein nicht ausreicht.",
    oneKey: "Ein Schlüssel für alles",
    restApiMcp: "REST-API + MCP",
    anyLanguage: "Jede Sprache, jeder Server",
    cta: "API & MCP entdecken",
  },
  premiumApps: {
    title: "Premium-Anwendungen",
    subtitle: "Echte, mehrstufige Anwendungen, keine Ein-Schritt-Tools -- auch eigenständig installierbar.",
    seeAll: "Alle Premium-Anwendungen ansehen",
  },
  googleDrive: {
    openFromGoogle: "Aus Google Drive öffnen",
    saveToGoogle: "In Google Drive speichern",
    signingIn: "Google-Anmeldung wird geöffnet...",
    fetching: "Datei wird aus Google Drive geholt...",
    saving: "Wird in Google Drive gespeichert...",
    saved: "In Google Drive gespeichert",
    viewInDrive: "In Drive ansehen",
    popupBlocked: "Ihr Browser hat das Google-Anmeldefenster blockiert. Erlauben Sie Pop-ups für diese Seite und versuchen Sie es erneut.",
    cancelled: "Die Google-Anmeldung wurde vor dem Abschluss geschlossen. Es wurde nichts geöffnet oder gespeichert.",
    denied: "Der Zugriff auf Google Drive wurde nicht erlaubt, daher wurde nichts geöffnet oder gespeichert. Versuchen Sie es erneut und erlauben Sie den Zugriff auf gewählte Dateien.",
    loadFailed: "Google ist nicht erreichbar. Prüfen Sie Ihre Verbindung oder Ihren Inhaltsblocker und versuchen Sie es erneut.",
    network: "Die Verbindung zu Google Drive wurde unterbrochen. Bitte erneut versuchen.",
    tooLarge: "Diese Datei ist zu groß, um im Browser geöffnet zu werden.",
    api: "Google Drive konnte das nicht abschließen. Bitte erneut versuchen.",
    largeFile: "Diese Datei ist größer als 50 MB. Es kann länger dauern oder der Browser-Speicher kann knapp werden.",
    privacyNote: "Ihre Datei läuft zwischen Ihrem Browser und Google. Sie wird nicht an unsere Server gesendet.",
  },
};
